var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 30,
    viewBox: "0 0 6 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M0 0C0 2.41145 0.123457 4.60504 0.309025 6.31011C0.566774 8.67841 1.63046 10.2359 2.86418 11.2731L5.41982 13.4216C6.19339 14.0719 6.19339 15.9281 5.41982 16.5784L2.86417 18.7269C1.63046 19.7641 0.566775 21.3216 0.309026 23.6899C0.123457 25.395 0 27.5885 0 30V0Z",
    fill: "#00B200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClip);
export default __webpack_public_path__ + "static/media/icon_clip.07dc0df5db48f7ed74a853541ccc76eb.svg";
export { ForwardRef as ReactComponent };